module.exports = __webpack_public_path__ + "img/consultation_part1.a3d3a57a.png";